import React from "react";

import { ConfigureIcon } from "@packages/ds";
import { useIntl } from "react-intl";

import { Tooltip } from "ds/Tooltip";
import { environmentSelector } from "Reducers/environment";
import { useAppSelector } from "Store/hooks";

import * as S from "./ConfigureResourcesButton.styles";

type Props = {
  environmentConfigUrl: string;
  align?: "start" | "center" | "end";
  organizationId: string;
  projectId: string;
  environmentId: string;
};

export const ConfigureResourcesButton = ({
  environmentConfigUrl,
  align = "center",
  organizationId,
  projectId,
  environmentId
}: Props) => {
  const intl = useIntl();
  const environment = useAppSelector(state =>
    environmentSelector(state, {
      organizationId,
      projectId,
      environmentId
    })
  );
  const disabled =
    typeof environment === "undefined" || environment?.status === "inactive";

  const formatMessageId = disabled
    ? "configure_resources.button.disabled"
    : "configure_resources";

  return (
    <Tooltip
      tooltip={intl.formatMessage({ id: formatMessageId })}
      align={align}
      analyticId={formatMessageId}
    >
      <S.IconControlConfigure
        to={environmentConfigUrl}
        variant="link"
        content="icon"
        as={S.Link}
        disabled={disabled}
      >
        <ConfigureIcon />
      </S.IconControlConfigure>
    </Tooltip>
  );
};
